//Module Keys
let locales = {
    dashboard_device_model: "Device Model",
    dashboard_3_days: "0-3 days",
    dashboard_5_days: "4-5 days",
    dashboard_10_days: "6-10 days",
    dashboard_15_days: "11-15 days",
    dashboard_16_days: "+16 days",
};

//Merge Views
import createEditChart from 'Modules/dashboard/views/.components/chart/.components/forms/createEditChart/lan/en';
import deleteChart from 'Modules/dashboard/views/.components/chart/.components/deleteChart/lan/en';
import createEditDashboard from 'Modules/dashboard/views/.components/dashboardPanel/.components/createEditDashboard/lan/en';
import deleteDashboard from 'Modules/dashboard/views/.components/dashboardPanel/.components/deleteDashboard/lan/en';
import dragDropContainer from 'Modules/dashboard/views/.components/dashboardPanel/.components/dragDropContainer/lan/en';
import createEditGadget from 'Modules/dashboard/views/.components/dashboardPanel/.components/gadgets/.components/createEditGadget/lan/en';
import menuActions from 'Modules/dashboard/views/.components/dashboardPanel/.components/menuActions/lan/en';
import vidFleetClipRequestsDetails from 'Modules/dashboard/views/.components/dashboardPanel/.components/vidFleetClipRequestsDetails/lan/en';
import devicesByStatus from 'Modules/dashboard/views/.components/chart/.components/devicesByStatus/lan/en';
import lastReadingDetails from 'Modules/dashboard/views/.components/dashboardPanel/.components/lastReadingDetails/lan/en';


locales = {
    ...locales,
    ...createEditChart,
    ...deleteChart,
    ...createEditDashboard,
    ...deleteDashboard,
    ...dragDropContainer,
    ...createEditGadget,
    ...menuActions,
    ...vidFleetClipRequestsDetails,
    ...devicesByStatus,
    ...lastReadingDetails,
};


export default locales;